import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LiveEventDashboardComponent } from './live-event-dashboard/live-event-dashboard.component';
import { LiveEventViewModel } from 'src/app/_models/generatedModels';
import { LiveEventService } from "../../_services/generatedServices";
import { ToasterService } from "../../_services/toaster.service";
import { EventRole } from 'src/app/_models/models';


@Component({
  selector: 'bxl-technical-support',
  templateUrl: 'technical-support.component.html',
})
export class TechnicalSupportComponent implements OnInit {
  initialized = false;
  @Input() parent: LiveEventDashboardComponent;
  @Input() role: EventRole;
  public EventRole = EventRole;
  @Input() event: LiveEventViewModel;
  @Output()
  closed = new EventEmitter();
   submitComplete: Promise<any>;

  constructor(private liveEventService: LiveEventService, private toaster: ToasterService) { }

  ngOnInit(): void {
    this.initialized = true;
  }

  toggleCompatibility() {
    this.parent.toggleCompatabilityMode();
  }

  refresh() {
    this.parent.reloadVideo();
  }

  supportChat() {
    this.parent.openSupportChat();
    this.close();
  }

  close() {
    //this.preTest = false;
    //this.techSupport = false;
    this.closed.emit();
  }

  public requestModerator() {
    this.submitComplete = new Promise((resolve: any, reject) => {
      this.liveEventService.requestSupport(this.event.id).subscribe(() => {
        resolve();
        this.toaster.messageDialog("Your request has been sent to the moderator. A member of the BehaviorLive team will meet you in here shortly.", "Request Sent").subscribe();
      });
    });
  }
}
